import {DistributionTypes, IDistribution} from "@/lib/monteCarlo/interfaces";
import {PerRoadLayerType} from "@/modules/perRoad/interfaces/perRoad";


export const acModulusByGrade: { [index: number]: number } = {
  82: 522859,
  76: 522859,
  70: 522859,
  64: 399702,
  58: 148918,
  52: 99608,
};
export const modulusByLayerType_psi = {
  [PerRoadLayerType.AC]: 522958,
  [PerRoadLayerType.CRACKED_AC]: 522958,
  [PerRoadLayerType.GRANULAR_BASE]: 20000,
  [PerRoadLayerType.ROCK]: 1000000,
  [PerRoadLayerType.SOIL]: 15000,
  [PerRoadLayerType.BS_PCC]: 500000,
  [PerRoadLayerType.CS_PCC]: 500000,
  [PerRoadLayerType.RUBBLIZED_PCC]: 500000,
  [PerRoadLayerType.PCC]: 4000000,
  [PerRoadLayerType.OTHER]: 500000,
};

export const granularModulusDistribution: IDistribution = {
  id: null,
  name: 'Granular Base Modulus (PSI)',
  max: 50000,
  mean: 20000,
  min: 5000,
  mode: null,
  std: 2000, // From Coeff of variation of 50% in PR4.4
  location: Math.log(12000),
  shape: 1,
  prob: DistributionTypes.normal,
};
export const soilModulusDistribution: IDistribution = {
  id: null,
  name: 'Soil Modulus (PSI)',
  max: 20000,
  mean: 15000,
  min: 11000,
  mode: null,
  std: 0.1 * 12000, // From Coeff of variation of 50% in PR4.4
  location: Math.log(12000),
  shape: 1,
  prob: DistributionTypes.normal,
};
export const soilThicknessDistribution: IDistribution = {
  id: null,
  name: 'Soil Thickness (in)',
  max: null,
  mean: 999,
  min: null,
  mode: null,
  std: null, // From Coeff of variation of 50% in PR4.4
  location: null,
  shape: null,
  prob: DistributionTypes.deterministic,
};

/*
 Create a default surface asphalt layer
 */
export const acModulusDistribution: IDistribution = {
  id: null,
  name: 'AC Modulus (PSI)',
  max: 4000000,
  min: 50000,
  mean: 522958,
  mode: null,
  std: 0.1 * 522958,
  prob: DistributionTypes.lognormal,
  location: Math.log(522958),
  shape: 0.3,
};

export const acThicknessDistribution: IDistribution = {
  id: null,
  name: 'Thickness (in)',
  max: null,
  mean: 10,
  min: null,
  mode: null,
  std: 0.05 * 10, // From Coeff of variation of 5% in PR4.4
  location: Math.log(10),
  shape: 0.15,
  prob: DistributionTypes.normal,
};
